export function SkeletonLoader() {
  return (
    <div className="pointer-events-none relative z-0 flex h-full w-full gap-8 overflow-hidden rounded-xl border border-gray-300 bg-white p-6 shadow-sm before:absolute before:bottom-0 before:left-1/2 before:right-0 before:top-0 before:z-[1] before:-ml-[250%] before:w-[500%] before:animate-[shimmer_0.8s_linear_infinite] before:bg-gradient-to-r before:from-transparent before:from-[46%] before:via-white/35 before:via-[50%] before:to-transparent before:to-[54%] before:content-['']">
      {/* Left Menu Skeleton */}
      <div className="flex h-full flex-col bg-white">
        {/* Header skeleton */}
        <div className="mb-6 mt-2">
          <div className="h-7 w-40 rounded bg-gray-200" />
        </div>

        {/* Menu Items skeleton */}
        <div className="space-y-1">
          <div className="h-10 rounded-md bg-gray-200" />
          <div className="h-10 rounded-md bg-gray-200" />
          <div className="h-10 rounded-md bg-gray-200" />
        </div>

        {/* Daily Credits skeleton */}
        <div className="mt-8">
          <div className="h-24 w-full rounded-md bg-gray-200" />
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="flex flex-1 flex-col">
        {/* Tab navigation skeleton */}
        <div className="h-10 w-full rounded bg-gray-200" />

        {/* Main content skeleton */}
        <div className="relative my-6 box-border flex flex-1 overflow-hidden bg-white">
          <div className="h-full w-full rounded-md bg-gray-200" />
        </div>

        {/* Next button skeleton */}
        <div className="h-12 w-24 rounded bg-gray-200" />
      </div>
    </div>
  );
}
